// List setting collections with design page.
// They must be handle to distinguish them from regular collections. (Ex: select-a...)
window.DYOcollections = {
  "select-a-ring": "/pages/design-your-own-ring",
  "select-an-earrings": "/pages/design-your-own-earrings",
  "select-a-necklace": "/pages/design-your-own-necklace"
}

// Func analysis option 'Center Stone Size'
function analysisOptions(options) {
  let otherOptions = [], from = 0, to = 0;

  options.forEach(option => { // ["0.15 - 0.49Ct", "Metal", "18k Gold", ...];
    const match = option.match(/(\d+(\.\d+)?)\s*-\s*(\d+(\.\d+)?)\s*Ct/);
    if (match) {
      from = match[1];
      to = match[3];
    } else {
      otherOptions.push(option);
    }
  });

  return {
    from: from,                 // 0.15
    to: to,                     // 0.49
    otherOptions: otherOptions  // ["Metal", "18k Gold", ...]
  };
}
window.DYOanalysisOptions = analysisOptions;



function initializeDyoData(settingHandle, stoneHandle = '', start = 'setting') {
  const dyoData = JSON.parse(localStorage.getItem('dyo_data'));
  if (
    start !== 'stone'
    && dyoData?.process?.setting?.urlCollection?.includes(settingHandle)
  ) {
    return;
  }

  let settingType = settingHandle.split('-').pop();
  let iconStone = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/icon-stone_53a07922-da1b-42f1-a963-5896711e57e1.png?width=100';
  let iconSetting;
  switch (settingType) {
    case 'earrings':
      iconSetting = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/earring-active.png?width=100'
      break;
    case 'necklace':
      iconSetting = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/icon-necklaces-active.png?width=100'
      break;
    default:
      iconSetting = 'https://cdn.shopify.com/s/files/1/0799/4251/7035/files/icon-ring-active.png?width=100';
      break;
  }

  const data = {
    general: {
      designUrl: `/pages/design-your-own-${settingType}`,
      collections: {
        setting: settingHandle,
        diamond: `select-a-diamond${settingType == 'earrings' ? '-pair' : ''}`,
        stone: `select-a-gemstone${settingType == 'earrings' ? '-pair' : ''}`
      },
      heading: `Design Your Own ${settingType}`
    },
    process: {
      setting: {
        position: start === 'setting' ? 1 : 2,
        img: iconSetting,
        urlCollection: start === 'setting' ? `/collections/${settingHandle}` : '',
      },
      stone: {
        position: start === 'stone' ? 1 : 2,
        img: iconStone,
        urlCollection: start === 'stone' ? `/collections/${stoneHandle}` : ''
      }
    }
  }

  // Set data into Localstorage
  localStorage.setItem('dyo_data', JSON.stringify(data));
}
window.DYOinitializeDyoData = initializeDyoData;



function checkProcess() {
  var currentUrl = window.location.href;
  const dyoData = JSON.parse(localStorage.getItem('dyo_data'));
  
  if ( /* If in DYO process  */
    currentUrl.includes("/collections/select-a")
    || window.location.hash === "#dyo"
    || currentUrl.includes("/pages/confirmation-dyo") && !currentUrl.split('?')[1]
  ) {
    window.DYO_in_process = '#dyo'; // In process DYO

    /* View DYO collection page if dyo_data is empty then redirect to design page */
    const collectionSetting = Object.keys(window.DYOcollections).find(key => currentUrl.includes(key));
    if (collectionSetting) {
      if (!Object.values(dyoData?.general?.collections ?? {}).includes(collectionSetting)) {
        // window.location.replace(window.DYOcollections[collectionSetting]);
        window.DYOinitializeDyoData(collectionSetting);
        return;
      }
    }

    /* Redirect to design page if dyo_data has not been initialized and see stone/diamond collection  */
    if (
      currentUrl.includes("/collections/select-a-gemstone") || currentUrl.includes("/collections/select-a-diamond")
    ) {
      if (
        !Object.values(dyoData?.general?.collections ?? {}).find(key => window.location.pathname === `/collections/${key}`)
        || dyoData?.process?.stone?.position == 1 && window.location.pathname != dyoData?.process?.stone?.urlCollection?.split('?')[0]
        || dyoData?.process?.stone?.position == 2 && !dyoData?.process?.setting?.productHandle
      ) {
        if (currentUrl.includes("-pair")) {
          window.location.replace(window.DYOcollections['select-an-earrings']);
          return;
        }
        window.location.replace(window.DYOcollections['select-a-ring']);
        return;
      }
      
    }

    /* Redirect to homepage if dyo_data has not been initialized  */
    if (
      !dyoData?.general?.collections
      || !dyoData?.process?.setting?.position
      || !dyoData?.process?.stone?.position
    ) {
      window.location.replace("/");
      return;
    }

    /* View DYO collection page (stone) if handle not valid with dyoData.general.collections then redirect to homepage  */
    if (
      currentUrl.includes("/collections/select-a")
      && !Object.values(dyoData.general.collections).some(handleValid => currentUrl.includes(handleValid))
    ) {
      window.location.replace("/");
      return;
    }
  }
}
window.DYOcheckProcess = checkProcess;